// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f487410e","453":"081cf257","732":"86c33418"}[chunkId] + ".chunk.js";
};